<template>
    <div class="ht-tab-wrap">
      <div class="section-title-wrapper text-center section-space--mb_30">
        <h5 class="section-title font-width-light wow move-up">Soin des ongles</h5>
      </div>
        <b-tabs class="ht-tab-menu wow move-up">
            <b-tab title="Ongles épais" active>
                <!-- tab content one component -->
                <OnglesEpais />
            </b-tab>
            <b-tab title="Ongles mycotiques">
                <!-- tab content two component -->
                <OnglesMycotiques />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import OnglesEpais from '@/components/pied-pro-custom/soins/ongles/OnglesEpais'
    import OnglesMycotiques from '@/components/pied-pro-custom/soins/ongles/OnglesMycotiques'

    export default {
        name: 'OnglesContainer',
        components: {
          OnglesEpais,
          OnglesMycotiques
        }
    };
</script>